import { Page } from '@/core/architecture'

import { MyOwnedTicketsEventSelectionTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * MyOwnedTicketsEventSelection Page
 * Implemented as a practical sample.
 */
export const MyOwnedTicketsEventSelection: Page = () => {
  const { state, actions } = useViewModel()

  return <MyOwnedTicketsEventSelectionTemplate state={state} {...actions} />
}
